import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import ReactHtmlParser from 'react-html-parser'
import { HELPER, CONSTANTS } from '../../utils'
import { alertActions } from '../../store/actions'
import { useToaster, useCustomAlerts } from '../../hooks'

let timeoutTime

function AlertComponent() {
	let { addToast } = useToaster()
	let dispatch = useDispatch()
	let { removeAllToasts } = useToaster()

	const { message, type, group, clearAll, autoDismiss } = useSelector((state) => state.toast)

	useEffect(() => {
		if (!HELPER.isEmpty(message) && !HELPER.isEmpty(type)) {
			group !== CONSTANTS.ERROR_TYPE.TOAST && window.scrollTo(0, 0)
		}
		// returned function will be called on component unmount
		return () => {
			if (!HELPER.isEmpty(message) && group === CONSTANTS.ERROR_TYPE.ALERT) {
				dispatch(alertActions.clear())
			}
			clearTimeout(timeoutTime)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	})

	useEffect(() => {
		if (!HELPER.isEmpty(message) && group === CONSTANTS.ERROR_TYPE.ALERT) {
			timeoutTime = setTimeout(() => {
				dispatch(alertActions.clear())
			}, 5000)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [message, type, group])

	useEffect(() => {
		// TOAST ALERTS
		if (!HELPER.isEmpty(message) && !HELPER.isEmpty(type) && group === CONSTANTS.ERROR_TYPE.TOAST) {
			addToast(ReactHtmlParser(message), {
				appearance: type,
				autoDismiss: autoDismiss,
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [message, type])

	useEffect(() => {
		removeAllToasts()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clearAll])

	return useCustomAlerts()
}

export default AlertComponent
